import { inject, Injectable } from '@angular/core'
import { SentryErrorHandler } from '@sentry/angular'
import { isAfter, subMinutes } from 'date-fns'
import { AnonymousData } from '../../rest/decorators/mapped'
import { LOCAL_STORAGE } from '../tokens/local-storage'
import { WINDOW } from '../tokens/window'

@Injectable()
export class GlobalErrorHandler extends SentryErrorHandler {
  private window = inject(WINDOW)
  private localStorage = inject(LOCAL_STORAGE)
  private readonly STORAGE_KEY = 'chunkReloaded'

  constructor() {
    super({})
  }

  override handleError(error: unknown): void {
    const message = (error as AnonymousData)['message']
    if (typeof message === 'string') {
      const firstLine = message.split('\n')[0]
      if (
        firstLine.match(/chunk-(.*?)\.js/) ||
        firstLine.includes('Importing a module script failed')
      ) {
        if (this.shouldReload()) {
          this.window?.location.reload()
        }
        return
      }
    }

    super.handleError(error)
  }

  private shouldReload(): boolean {
    const reloaded = this.localStorage.getItem(this.STORAGE_KEY)
    if (reloaded && isAfter(new Date(reloaded), subMinutes(new Date(), 1))) {
      return false
    }
    this.localStorage.setItem(this.STORAGE_KEY, new Date().toISOString())
    return true
  }
}
